import EBRMaterialsCreateFolderModal from "./EBRMaterialsCreateFolderModal";

export default EBRMaterialsCreateFolderModal;
